var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarMidnight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ee9730e8-ebf2-4aa2-8a1d-054ca8caaf01"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "fe30751b-da1e-440b-9098-137d221dfa0e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 569.65 412.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-350.02, -262.85)",
    d: "M 584.75 209.61 C 584.09375 207.5944 582.3594 206.1217 580.2695 205.8014 L 424.6495 183.4034 L 355.0405 42.11340000000001 C 354.10691 40.179800000000014 352.1499 38.95320000000001 350.0014 38.95320000000001 C 347.8529 38.95320000000001 345.8959 40.17980000000001 344.96229999999997 42.11340000000001 L 275.3533 183.17340000000002 L 119.73329999999999 205.5714 C 117.64349999999999 205.89171000000002 115.90909999999998 207.3683 115.25279999999998 209.38000000000002 C 114.64732999999998 211.36440000000002 115.18639399999998 213.51670000000001 116.65509999999998 214.98160000000001 L 229.27509999999998 324.7416 L 202.67309999999998 480.0816 C 202.26294 482.2222 203.13794 484.4097 204.9114 485.67929999999996 C 206.63019999999997 486.93319999999994 208.9075 487.10509999999994 210.7942 486.12852 L 350.00419999999997 412.82352 L 489.2142 486.01451999999995 C 490.01108 486.42467999999997 490.89390000000003 486.63560999999993 491.7923 486.63170999999994 C 492.9759 486.6356159999999 494.1361 486.26451999999995 495.09700000000004 485.56530999999995 C 496.8704 484.29580999999996 497.7454 482.11220999999995 497.3353 479.96761 L 470.73330000000004 325.06760999999995 L 583.3533 215.30760999999995 L 583.3533 215.31151599999995 C 584.865 213.82321599999995 585.4041 211.61621599999995 584.7556 209.60061599999995 z M 460.82 319.20000000000005 C 459.5036 320.47730000000007 458.8981 322.32110000000006 459.195 324.12970000000007 L 484.394 470.78970000000004 L 352.624 401.5167 C 350.96380000000005 400.69639 349.0185 400.69639 347.3584 401.5167 L 215.5884 470.78970000000004 L 240.73340000000002 324.0697 L 240.72949400000002 324.065793 C 241.03027400000002 322.257193 240.42480400000002 320.417393 239.108394 319.139993 L 132.708394 215.199993 L 279.98839399999997 193.80899300000002 L 279.984488 193.80899300000002 C 281.828288 193.551183 283.421988 192.398793 284.242288 190.72699300000002 L 349.984288 57.27699300000003 L 415.839288 190.72699300000002 C 416.659598 192.39889300000002 418.25338800000003 193.551193 420.097088 193.80899300000002 L 567.377088 215.199993 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 562.42 414.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(30,0,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-349.99, -285.49)",
    d: "M 588.84 224.07 L 440.23 202.441 C 433.0894 201.46053 426.85900000000004 196.9098 423.64000000000004 190.40200000000002 L 357.14000000000004 55.792 C 354.40950000000004 50.190400000000004 345.58900000000006 50.190400000000004 342.85900000000004 55.721688 L 276.35900000000004 190.471688 C 273.14020000000005 196.913088 266.9098 201.459688 259.76900000000006 202.440688 L 111.15900000000005 224.06968799999999 C 108.08090000000004 224.557968 105.69810000000005 226.51888799999998 104.71760000000005 229.460288 C 103.73713000000005 232.47198799999998 104.50666000000005 235.550088 106.74880000000005 237.72198799999998 L 214.33880000000005 342.58198799999997 C 219.51850000000005 347.621088 221.82710000000006 354.90198799999996 220.63960000000006 361.972988 L 195.29960000000005 510.022988 C 194.74101000000005 513.101088 195.92851000000005 516.042488 198.44800000000006 517.862788 C 200.89720000000005 519.683088 204.04960000000005 519.893988 206.84640000000007 518.491698 L 339.7064000000001 448.56169800000004 C 342.9955000000001 446.881998 346.4955000000001 446.112498 349.9954000000001 446.112498 C 353.49530000000004 446.112498 356.9954000000001 446.882028 360.1434000000001 448.491398 L 493.2134000000001 518.491398 C 495.9439000000001 519.889798 499.0220000000001 519.682798 501.5415000000001 517.862488 C 504.0610000000001 516.0421779999999 505.2524000000001 513.100788 504.6899000000001 510.02268799999996 L 479.3499000000001 361.97268799999995 C 478.1585000000001 354.902388 480.4710000000001 347.620688 485.6507000000001 342.58168799999993 L 593.2407000000001 237.72168799999992 C 595.479 235.54978799999992 596.2524000000001 232.47168799999992 595.2719000000001 229.45998799999992 C 594.2914300000001 226.51858799999994 591.9125 224.56158799999992 588.8305 224.06938799999992 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMidnight);
export default __webpack_public_path__ + "static/media/StarMidnight.d71069dab59c0459c3f35bfb9d58b9b8.svg";
export { ForwardRef as ReactComponent };